import React from 'react';

import { CardViewStyles, } from './CardViewStyles';

export interface CardTitleProps {
  readonly name: string;
  readonly missingStyle?: boolean;
}

export class CardTitle extends React.Component<CardTitleProps> {
  public render() {
    return <h3
      className={this.props.missingStyle ? CardViewStyles.ActionRowNameMissing : CardViewStyles.ActionRowName}
      title={this.props.name}
      data-tb-test-id="content-name">
        {this.props.name}
    </h3>;
  }
}

